/**
 * Lisbon Racket League design tokens.
 *
 * Mirrors design/reference/lisbon-racket-league/project/src/tokens.jsx.
 * Consumed by:
 *   - globals.css   (declares CSS custom properties)
 *   - tailwind-preset.ts (Tailwind theme extension)
 *   - @lrl/ui components for inline styling where Tailwind isn't enough
 */

export const LRL_TOKENS = {
  // ─── Surfaces ────────────────────────────────────────────
  bg:         'oklch(0.972 0.008 80)',
  bgSubtle:   'oklch(0.94 0.012 80)',
  card:       'oklch(0.985 0.005 80)',
  rule:       'oklch(0.88 0.012 80)',
  ruleStrong: 'oklch(0.78 0.015 80)',

  // ─── Text ────────────────────────────────────────────────
  ink:      'oklch(0.20 0.025 250)',
  inkSoft:  'oklch(0.42 0.025 250)',
  inkMuted: 'oklch(0.58 0.020 250)',

  // ─── Brand ───────────────────────────────────────────────
  primary:     'oklch(0.40 0.115 245)',
  primaryFg:   'oklch(0.985 0.005 80)',
  primarySoft: 'oklch(0.92 0.035 245)',
  accent:      'oklch(0.86 0.165 115)',
  accentInk:   'oklch(0.28 0.07 130)',
  clay:        'oklch(0.66 0.115 42)',
  claySoft:    'oklch(0.93 0.03 42)',

  // ─── Inverse (dark surfaces used sparingly) ──────────────
  inverseBg:  'oklch(0.22 0.025 250)',
  inverseFg:  'oklch(0.95 0.01 80)',

  // ─── Type families ───────────────────────────────────────
  serif: '"Instrument Serif", "Times New Roman", serif',
  sans:  '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
  mono:  '"Geist Mono", "JetBrains Mono", ui-monospace, monospace',

  // ─── Radii ───────────────────────────────────────────────
  rXs: '4px',
  rSm: '6px',
  r:   '8px',
  rLg: '12px',
  rXl: '18px',
} as const;

export type LrlToken = keyof typeof LRL_TOKENS;
export type LrlTokenValue = (typeof LRL_TOKENS)[LrlToken];
